import { getAccountHolderUser } from "./UserData";
import { consola } from "consola";

export const getHost = () => {
  // eslint-disable-next-line no-undef
  let forceEmulator = false;
  const emulatorHost = "127.0.0.1";
  const localDevHost = "localhost";
  if (
    window.location.hostname === emulatorHost ||
    (window.location.hostname === localDevHost &&
      // eslint-disable-next-line no-undef
      import.meta.env.VITE_EMULATOR === "true")
  ) {
    forceEmulator = true;
  }

  if (forceEmulator) {
    return "http://127.0.0.1:5002";
  }

  // eslint-disable-next-line no-undef
  if (import.meta.env.VITE_ENV === "production") {
    return "https://app.mighty45.com";
  } else {
    return "https://app.mighty45.com";
  }
};

export const getAPIBasePath = () => {
  const host = getHost();
  return `${host}/api/v1`;
};

export const getStripeProducts = async ({ organizationId }) => {
  if (!organizationId) {
    consola.error(new Error("Incorrect parameters"));
  }

  // eslint-disable-next-line no-undef
  const path = `${getAPIBasePath()}/stripe/subscription/`;

  const response = await fetch(`${path}${organizationId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    const jsonData = await response.json();
    return jsonData;
  }
  consola.error(
    new Error(`Error getting stripe response - ${response.status}`),
  );
};

export const createCheckoutSession = async ({ organizationId, tier }) => {
  if (!organizationId || !tier) {
    consola.error(new Error("Missing required parameters: organizationId and tier"));
    throw new Error("Missing required parameters");
  }

  if (tier !== "standard" && tier !== "pro") {
    consola.error(new Error(`Invalid tier: ${tier}. Must be 'standard' or 'pro'`));
    throw new Error("Invalid tier. Must be 'standard' or 'pro'");
  }

  const path = `${getAPIBasePath()}/stripe/checkout`;

  const response = await fetch(path, {
    method: "POST",
    body: JSON.stringify({
      organizationId,
      tier,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const jsonData = await response.json();
    return jsonData;
  }

  const errorData = await response.json().catch(() => ({ error: "Unknown error" }));
  consola.error(
    new Error(`Error creating checkout session - ${response.status}: ${errorData.error || "Unknown error"}`),
  );
  throw new Error(errorData.error || "Failed to create checkout session");
};

export const updateSubscriptionTier = async ({ organizationId, tier }) => {
  if (!organizationId || !tier) {
    consola.error(new Error("Missing required parameters: organizationId and tier"));
    throw new Error("Missing required parameters");
  }

  if (!["free", "standard", "pro"].includes(tier)) {
    consola.error(new Error(`Invalid tier: ${tier}. Must be 'free', 'standard', or 'pro'`));
    throw new Error("Invalid tier. Must be 'free', 'standard', or 'pro'");
  }

  const path = `${getAPIBasePath()}/stripe/subscription/update`;

  const response = await fetch(path, {
    method: "POST",
    body: JSON.stringify({
      organizationId,
      tier,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const jsonData = await response.json();
    return jsonData;
  }

  const errorData = await response.json().catch(() => ({ error: "Unknown error" }));
  consola.error(
    new Error(`Error updating subscription tier - ${response.status}: ${errorData.error || "Unknown error"}`),
  );
  throw new Error(errorData.error || "Failed to update subscription tier");
};

export const updateSubscription = async ({ organizationId }) => {
  const stubbedOut = true;
  if (stubbedOut) {
    return true;
  }

  if (!organizationId) {
    consola.error(new Error("Incorrect parameters"));
  }

  const accountHolderUser = await getAccountHolderUser({ organizationId });

  consola.log("accountHolderUser", accountHolderUser);

  const message = {
    cart: {
      name: `${accountHolderUser.firstName} ${accountHolderUser.lastName}`,
      organization_id: organizationId,
    },
  };

  const path = `${getAPIBasePath()}/stripe_cart`;

  const response = await fetch(`${path}`, {
    method: "POST",
    body: JSON.stringify(message),
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    const jsonData = await response.json();
    return jsonData;
  }
  consola.error(
    new Error(`Error getting stripe response - ${response.status}`),
  );
};
